import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import type {
  CheckoutZone,
  DropZoneItem,
  DropZonePage,
} from "@/networking/drop-zones.api";
import { fetchDropZones } from "@/networking/drop-zones.api";

export default function useIdentifyDropzone(
  id: string,
  subdomain: string,
  page: DropZonePage,
) {
  const { data: dropZones } = useQuery({
    queryKey: ["drop-zones", id],
    queryFn: () => fetchDropZones({ fluidShop: subdomain }),
    enabled: !!subdomain,
  });

  const zoneMap = useMemo(() => {
    const map = new Map<CheckoutZone, DropZoneItem>();
    if (!dropZones?.drop_zones) return map;
    for (const dz of dropZones.drop_zones) {
      if (dz.active && dz.settings.page === page) {
        map.set(dz.settings.zone, dz);
      }
    }
    return map;
  }, [dropZones, page]);

  const getZone = useMemo(
    () => (zone: CheckoutZone) => zoneMap.get(zone) ?? null,
    [zoneMap],
  );

  return { getZone };
}
